import sanitizeHtml from 'sanitize-html';

/**
 * Converts HTML content to plain text for metadata
 * @param {string} html - HTML content to convert
 * @returns {string} - Plain text without HTML tags
 */
export function htmlToPlainText(html) {
  if (!html) return '';

  // Use sanitize-html to strip all HTML tags and keep only text content
  return sanitizeHtml(html, {
    allowedTags: [], // No tags allowed (strip all HTML)
    allowedAttributes: {}, // No attributes allowed
  });
}
